import { render, staticRenderFns } from "./LandingNoListIT.vue?vue&type=template&id=3bff3986&scoped=true"
import script from "./LandingNoListIT.vue?vue&type=script&lang=js"
export * from "./LandingNoListIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff3986",
  null
  
)

export default component.exports